// extracted by mini-css-extract-plugin
export var mainimage = "index-module--mainimage--OIfPY";